

export const getCheckInfo = (state, props) => state.checkIn.checkInfo;

export const getShowUsers = (state, props) => state.annotationUsers.annotationShowUsers;

export const getCheckQueryInfo = (state, props) => state.checkIn.queryInfo;

export const getCheckTabName = (state, props) => state.checkIn.tabName;